import axiosClient from '../api/axiosClient';

export const getWhatIsFuru = async (id: number) => {
  const data = await axiosClient.get(`1/intro?fc_id=${id}`);
  return data?.data;
};

export const getIntroByMode = async (mode: number, fc_id: string | null) => {
  const data = await axiosClient.get(`${mode + 1}/intro?fc_id=${fc_id}`);
  return data?.data;
};

export const getGroupIdFromFcId = async (mode: number, fc_id: string) => {
  return await axiosClient.get(`${mode}/get-group?fc_id=${fc_id}`);
};

export const getGroupsByPostCode = async (mode: any, postCode: any) => {
  try {
    const endPoint = `${mode}/${postCode}/groups`;

    return await axiosClient.get(endPoint);
  } catch (error: any) {
    return {
      status: 'error',
      message: error.message,
    };
  }
};

export const getDataFieldByMode = async (mode: number, fc_id: string | null) => {
  const data = await axiosClient.get(`${mode + 1}/${fc_id}/display-setting`);
  return data?.data;
};

export const checkUpdateAppVersion = async (mode: number, fc_id: string) => {
  try {
    const endPoint = `${mode + 1}/check-update?fc_id=${fc_id}`;
    return await axiosClient.get(endPoint);
  } catch (error) {
    return {
      data: {
        isForceUpdate: false,
      }
    };
  }
};